export default __webpack_public_path__ + "static/media/performance.0471b469.png";